export const LessonStatus = {
  NOT_STARTED: 0,
  STARTED: 1,
  PASSED: 2,
};
